import { MenuItem } from 'primeng/api';

export const HEADER_MENU_ITEMS: MenuItem[] = [
    { label: 'Current Menu', url: 'current-menu' },
    { label: 'How it Works', url: 'how-it-works' },
    { label: 'About Us', url: 'about-us' },
    { label: 'NG for Business', url: 'ng-for-business' },
    { label: 'FAQs', url: 'faq' },
    { label: 'Blog', url: 'blog' },
    { label: 'My Account', url: 'profile' }
];

export const MOBILE_MENU_ITEMS: MenuItem[] = HEADER_MENU_ITEMS.filter(
    item => item.url !== 'profile'
);
